<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <template v-if="!pageLoading">
      <v-row class="mb-1">
        <v-col cols="12">
          <filter-hoover-stats
            :default-search-params="searchParams"
            :is-component-loading="isRequestingNow"
            @filtering="onFilter"
            @download-excel="onDownloadExcel"
          ></filter-hoover-stats>
        </v-col>
      </v-row>

      <v-row v-if="data" class="mb-4">
        <v-col cols="12" sm="4" v-for="month in Object.keys(data)" :key="month">
          <v-card>
            <v-card-title>
              {{ formatMonth(month) }} <br>
              {{ $t('table.headers.table_column__base') }}: {{ totals[month] }} / {{ $t('table.headers.table_column__complex') }}: {{ totalsComplex[month] }}
              <br> {{ $t('table.headers.table_column__dry_cleaning') }}: {{ totalsComplexDryCleaning[month] }}
            </v-card-title>
            <v-divider />
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">{{ $t('table.headers.day') }}</th>
                    <th class="text-left">{{ $t('table.headers.table_column__base') }}</th>
                    <th class="text-left">{{ $t('table.headers.table_column__complex') }}</th>
                    <th class="text-left">{{ $t('table.headers.table_column__dry_cleaning') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in data[month]" :key="item.day">
                    <td>{{ item.day }}</td>
                    <td>{{ item.count }}</td>
                    <td>{{ (month in dataComplex && index in dataComplex[month]) ? dataComplex[month][index].count : '-' }}</td>
                    <td>{{ (month in dataComplexDryCleaning && index in dataComplexDryCleaning[month]) ? dataComplexDryCleaning[month][index].count : '-' }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <modal-loading :is-show="isTableLoading"></modal-loading>
  </v-container>
</template>

<script>
import moment from 'moment';
/* constants */
import downloadReport from '@/mixins/reports/downloadReport';
import StatsCreatedProxy from '@/proxies/Stats/StatsCreatedProxy';
import { MANAGER_TOP } from '@/constants/roles';
/* mixins */
import defaultListingMixin from '../../mixins/listing/defaultListingMixin';
import updatePageContentMixin from '../../mixins/updatePageContentMixin';

/* components */
import ModalLoading from '../../components/loaders/ModalLoading.vue';
import FilterHooverStats from '../../components/listings/FilterHooverStats.vue';

export default {
  name: 'OrderCreatedStats',
  mixins: [updatePageContentMixin, defaultListingMixin, downloadReport],
  components: {
    ModalLoading,
    FilterHooverStats,
  },
  data() {
    return {
      MANAGER_TOP,
      /* Page management */
      pageLoading: false,
      /* Listing management */
      isTableLoading: false,
      searchParams: {
        from: null,
        to: null,
        region: null,
        period: null,
      },
      reportMethodName: 'ordersCreatedListingReport',
      data: null,
      totals: null,
      dataComplex: null,
      totalsComplex: null,
      dataComplexDryCleaning: null,
      totalsComplexDryCleaning: null,
    };
  },
  computed: {
    /* store */
    account() {
      return this.$store.getters['account/account'];
    },
  },
  methods: {
    fetchData() {
      new StatsCreatedProxy(this.searchParams)
        .list()
        .then( ({ data: { data } }) => {
          this.data = data.base.stats;
          this.totals = data.base.totals;
          this.dataComplex = data.complex.stats;
          this.totalsComplex = data.complex.totals;
          this.dataComplexDryCleaning = data.complex_dry_cleaning.stats;
          this.totalsComplexDryCleaning = data.complex_dry_cleaning.totals;

          console.log('------------', Object.keys(this.data), this.data['2022-08']);
          console.log(this.dataComplex);

        })
        .catch(error => {
          this.data = null;
          console.error(error);
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    computedValue(a, b) {
      if (a === 0) {
        return 0;
      }
      return (a / b) * 100;
    },
    formatMonth(month) {
      moment.locale(window.localStorage.language);
      const date = moment(month);
      return date.format('MMMM, YYYY');
    },
  },
};
</script>

<style></style>
